import { useStaticQuery, graphql } from 'gatsby';

export const useIssueIndex = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allIssue(
          filter: { data: { draft: { eq: false } } }
          sort: { fields: data___date, order: DESC }
        ) {
          nodes {
            ...IssueIndexData
          }
        }
      }
    `
  );

  return data.allIssue.nodes;
};
